import React from "react";
import { Box, Grid } from "@mui/material";
// import LoginImg from "../../Images/atto_desk_login_background.webp";
import LoginImg from "../../Images/background.png";
import Login from "./Login";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, Theme } from '@mui/material/styles';

/**
 * Auth screen scaffold — background image, dark overlay, login card.
 *
 * Layout split by breakpoint:
 *   • md+ → asymmetric layout: card pinned to the right with a comfortable
 *           gutter so the background photo dominates the left two-thirds
 *           (the original brand intent).
 *   • <md → centered card with safe-area padding so the card never touches
 *           the screen edges and never overflows the viewport on iPhone /
 *           Android / small tablets. `overflowX: hidden` on the outer Box
 *           is a belt-and-braces guard against any nested element that
 *           tries to push past the viewport.
 */
const Auth: React.FC = () => {
  const theme = useTheme<Theme>();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ width: "100%", overflowX: "hidden" }}>
      <Box
        sx={{
          position: "relative",
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          // Right-aligned on desktop (brand layout), centered on mobile.
          justifyContent: { xs: "center", md: "flex-end" },
          // Safe gutter so the card never touches the screen edge on
          // mobile, plus the original right-side gutter on desktop.
          px: { xs: 2, sm: 3, md: 0 },
          pr: { md: 20 },
        }}
      >
        <Box
          component="img"
          src={LoginImg}
          alt="Background"
          sx={{
            objectFit: "cover",
            objectPosition: "center",
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
          }}
        />

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 0,
          }}
        />

        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            width: "100%",
            maxWidth: { xs: 420, sm: 440, md: 460 },
            mx: "auto",
            // Reset the desktop auto-margin so the parent's flex-end
            // alignment wins on md+.
            ...(isSmall ? {} : { mx: 0 }),
          }}
        >
          <Login />
        </Box>
      </Box>
    </Box>
  );
};

export default Auth;
